var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssetIsolate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,13.5714h3.4286V17H9V13.5714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9v3.4286h3.4286V9H9z M11.8571,11.8571H9.5714V9.5714h2.2857V11.8571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5714,9v3.4286H17V9H13.5714 M16.4286,11.8571h-2.2857V9.5714h2.2857V11.8571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5714,13.5714V17H17v-3.4286H13.5714z M16.4286,16.4286h-2.2857v-2.2857h2.2857V16.4286z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,0l5,5l-5,5L0,5L5,0z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssetIsolate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/asset-isolate.29294f05348e5f13ecde61085489c3fe.svg";